{
  "main": {
    "title": "Pregled površin",
    "subtitle": "Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov",
    "titleOddan": "Pregled za današnji dan opravljen",
    "contentOddan": "Pregled steze za današnji dan je že bil opravljen, ali želiš oddati dodatnega?",
    "nazaj": "Nazaj"
  },
  "nav": {
    "vnos": "vnos",
    "zapisi": "zapisi"
  },
  "obrazecA": {
    "title": "A. LETALIŠČE (AERODROME)",
    "description": "Osnovne informacije o letališču",
    "formLabel1": "ICAO koda (4 črke)",
    "formLabel2": "Ime letališča"
  },
  "obrazecB": {
    "title": "B. DATUM IN ČAS PREGLEDA (LOKALNI ČAS)",
    "description": "Čas in datum pregleda površin",
    "formLabel1": "Datum (DD.MM.YYYY)",
    "formLabel2": "Čas (HHMM)"
  },
  "obrazecC": {
    "title": "C. OZNAKA VZLETNO-PRISTAJALNE STEZE",
    "description": "Oznaka vzletno-pristajalne steze",
    "formLabel1": "Oznaka steze (XX-XX)"
  },
  "obrazec1": {
    "title": "1. STANJE NA POVRŠINI (SURFACE CONDITION)",
    "description": "Stanje površin na različnih območjih letališča",
    "surfaceLabel": "Površina",
    "vse": "vse",
    "ploscadi": "Ploščadi"
  },
  "obrazec3": {
    "title": "3. POMANJKLJIVOSTI (DEFICIENCIES)",
    "description": "Pregled pomanjkljivosti na površinah",
    "surfaceLabel": "Pomanjkljivost",
    "vse": "vse",
    "ploscadi": "Ploščadi"
  },
  "obrazec4": {
    "title": "4. OVIRE (OBSTACLES)",
    "description": "Pregled ovir na površinah",
    "surfaceLabel": "Ovira",
    "vse": "vse",
    "ploscadi": "Ploščadi"
  },
  "obrazec5": {
    "title": "5. PRISOTNOST PTIC (PRESENCE OF BIRDS)",
    "description": "Pregled prisotnosti ptic na površinah",
    "surfaceLabel": "Ptica",
    "gridLabel":"Prisotnost ptic",
    "vse": "vse",
    "ploscadi": "Ploščadi"
  },
  "obrazec6": {
    "title": "6. OPOMBE (REMARKS)",
    "description": "Dodatne opombe in pripombe",
    "surfaceLabel": "Opomba",
    "gridLabel":"Opombe",
    "vse": "vse",
    "ploscadi": "Ploščadi"
  },
  "obrazec7": {
    "title": "7. PREGLED (INSPECTION)",
    "description": "Pregled helikopterskih pristajalnih ploščadi",
    "surfaceLabel": "Pregled",
    "gridLabel": "Ploščadi za pristajanje helikopterjev",
    "vse": "vse",
    "vseOK": "vse ok",
    "ploscadi": "Ploščadi"
  },
  "conditions": {
    "dryClean": "a) suho in čisto",
    "damp": "b) vlažno",
    "wet": "c) mokro",
    "puddles": "d) luže",
    "waterLayer": "e) vodna plast"
  },
  "deficiency": {
    "surfaceDamage": "poškodbe utrjenega vozišča",
    "foreignObjects": "tuji predmeti",
    "unevenness": "neravnine, večje od dovoljenih",
    "horizontalMarkings": "vodoravne oznake",
    "verticalMarkings": "navpične oznake",
    "safetyStrip": "varnostni pas in osnovna steza",
    "other": "drugo"
  },
  "zapisi": {
    "title": "Zapisi pregledov površin",
    "description": "Pregled vseh poslanih obrazcev za pregled površin",
    "ni": "Ni zapisov",
    "niDescription": "Pregled površin še ni bil poslan. Uporabite zavihek 'Vnos' za izpolnjevanje obrazca.",
    "info": "Če dokumenta ne vidite uporabite gumb za prenos datoteke",
    "posiljam": "Pošiljam..."
  },
  "buttons": {
    "pocisti":"Počisti obrazec",
    "poslji":"Pošlji obrazec",
    "prenesi":"Prenesite dokument"
  },
  "labels": {
    "datum": "Datum"
  },
  "obvestila": {
    "zapisPrihodnost": "Zapis ima izbran datum v prihodnosti, POPRAVI izbran datum!",
    "zapisCasPrihodnost": "Zapis ima pri enem ali več zapisih uro v prihodnosti, preglej čase!",
    "zapisCasNapaka": "Časi zapisov so nepravilni! Preveri čase še enkrat!",
    "zapisDodan": "Zapis uspešno dodan",
    "napakaPristanka": "Čas pristanka ne more biti pred časom poleta!",
    "zapisPobrisan": "Zapis uspešno pobrisan",
    "napakaPrazenPristanek": "Napaka pri vnosu, čas pristanka ne more biti prazen",
    "posodobitevUspesna": "Posodobitev uspešna",
    "napakaPosodabljanja": "Napaka pri posodabljanju podatkov.",
    "napakaBranja": "Napaka pri branju podatkov.",
    "napakaIzbrisa": "Napaka pri izbrisu podatkov.",
    "vprasanjeIzbris": "Ali res želite pobrisati zapis?",
    "napakaVnosaPolja": "Napaka pri vnosu, preglej če imaš izpolnjena vsa polja!",
    "napakaVnosa": "Napaka pri vnosu podatkov",
    "napakaValidacije": "Napaka pri validiranju polj! Preglej če imaš izpolnjena vsa polja!",
    "letZakljucen": "Let uspešno zaključen.",
    "letNiZakljucen": "Napaka pri zaključevanju leta."
  }
}